import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '1', label: 'Produção' },
			{ value: '2', label: 'Homologação' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

